document.addEventListener('DOMContentLoaded', () => {
    if (!window.SaborlistaInfinite) {
        return;
    }

    const { apiRoot, context, debug, nonce, historyViewDuration, syncSidebar } = window.SaborlistaInfinite;

    const icLog = (...args) => {
        if (debug) {
            console.log('[InfiniteContent]', ...args);
        }
    };

    const icError = (...args) => {
        if (debug) {
            console.error('[InfiniteContent]', ...args);
        }
    };

    // Сбор ID всех постов, которые уже есть на странице (WP обычно добавляет класс post-123)
    const initialIds = Array.from(document.querySelectorAll('article[class*="post-"], .post-item[id*="post-"]'))
        .map(el => {
            const match = el.className.match(/post-(\d+)/) || el.id.match(/post-(\d+)/);
            return match ? parseInt(match[1]) : null;
        })
        .filter(id => id !== null);

    // Instantiate Modules
    const apiContext = { ...context };
    if (apiContext.initial_meta) delete apiContext.initial_meta;

    const queueManager = new SaborlistaQueueManager(apiRoot, apiContext, debug, nonce);
    const uiController = new SaborlistaUIController(context);
    const injector = new SaborlistaDomInjector();

    const landingUrl = window.location.href;

    if (!history.state) {
        history.replaceState({ 
            url: window.location.href, 
            title: document.title 
        }, document.title, window.location.href);
        icLog('History state initialized');
    }

    let isProgrammaticScroll = false;
    let lastTrackedUrl = window.location.href; 
    let viewTimer = null; // Таймер для persistent history

    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }

    let preFetchedBatchHtml = null;

    const setupItemObservers = (el) => {
        observer.observeItem(el);
        
        const planSentinel = document.createElement('div');
        planSentinel.className = 'infinite-plan-sentinel';
        planSentinel.style.position = 'absolute';
        planSentinel.style.top = '20%';
        planSentinel.style.height = '1px';
        planSentinel.style.width = '1px';
        planSentinel.style.pointerEvents = 'none';
        planSentinel.style.opacity = '0';
        el.appendChild(planSentinel);
        observer.observeTrigger(planSentinel, 'plan');

        const htmlSentinel = document.createElement('div');
        htmlSentinel.className = 'infinite-html-sentinel';
        htmlSentinel.style.position = 'absolute';
        htmlSentinel.style.top = '40%';
        htmlSentinel.style.height = '1px';
        htmlSentinel.style.width = '1px';
        htmlSentinel.style.pointerEvents = 'none';
        htmlSentinel.style.opacity = '0';
        el.appendChild(htmlSentinel);
        observer.observeTrigger(htmlSentinel, 'html');
    };

    const loadAndInjectNextSingle = async () => {
        if (queueManager.isFetchingPlan || queueManager.isFetchingItems) return null;

        uiController.setLoading(true);

        if (queueManager.queue.length === 0) {
            await queueManager.fetchPlan();
        }

        const item = await queueManager.getNextItem();
        if (item && item.html) {
            icLog('Injecting item:', item.id);
            const newEl = injector.inject(item.html, item.meta);
            mainContainer.appendChild(sentinel);
            if (newEl) {
                // Добавляем ID во временный список сессии для дедупликации на текущей странице
                queueManager.addSessionId(item.id);
                setupItemObservers(newEl);
                uiController.setNextAnchor(newEl);
                uiController.setLoading(false);
                return newEl;
            }
        }
        
        uiController.setLoading(false);
        return null;
    };

    // Передаем начальные ID в менеджер очередей как session-only (для дедупликации на странице)
    if (initialIds.length > 0) {
        initialIds.forEach(id => queueManager.addSessionId(id));
        icLog('Initial IDs (Session):', initialIds);
    }

    const mainContainer = document.querySelector('main') || document.body;
    
    const pagination = document.querySelector('.pagination, .nav-links, .page-navigation');
    if (pagination) {
        pagination.style.display = 'none';
        icLog('Original pagination hidden');
    }

    const sentinel = document.createElement('div');
    sentinel.className = 'infinite-sentinel';
    sentinel.style.height = '10px';
    sentinel.style.width = '100%';
    mainContainer.appendChild(sentinel);

    const observer = new SaborlistaScrollObserver({
        onLoadMore: async (source = 'sentinel') => {
            if (queueManager.queue.length === 0) {
                await queueManager.fetchPlan();
                
                if (queueManager.queue.length === 0) {
                     icLog('No more content to load.');
                     return;
                }
            }

            if (queueManager.isFetchingPlan || queueManager.isFetchingItems) {
                return;
            }

            const isSingle = context.type === 'single';

            if (isSingle) {
                await loadAndInjectNextSingle();
            } else {
                icLog('Loading batch from queue...');
                
                let data = null;
                if (preFetchedBatchHtml) {
                    data = await preFetchedBatchHtml;
                    preFetchedBatchHtml = null;
                } else {
                    const items = [...queueManager.queue];
                    queueManager.queue = []; 
                    if (items.length > 0) {
                        data = await queueManager.fetchHtmlBatch(items);
                    }
                }

                if (data && data.html) {
                    icLog(`Batch injected (${data.count || 0} items)`);
                    const addedEls = injector.injectBatch(data.html);
                    
                    mainContainer.appendChild(sentinel);
                    
                    if (data.meta && addedEls && addedEls.length > 0) {
                        const firstEl = addedEls.find(el => el.nodeType === 1);
                        if (firstEl) {
                            firstEl.classList.add('ic-level-block');
                            firstEl.setAttribute('data-url', data.meta.url);
                            firstEl.setAttribute('data-title', data.meta.title);
                            firstEl.setAttribute('data-meta', JSON.stringify(data.meta));
                            observer.observeItem(firstEl);
                        }
                    }

                    if (addedEls && addedEls.length > 0) {
                        const lastEl = addedEls[addedEls.length - 1];
                        if (lastEl && lastEl.nodeType === 1) {
                            lastEl.style.position = 'relative';

                            const planSentinel = document.createElement('div');
                            planSentinel.className = 'infinite-plan-sentinel';
                            planSentinel.style.position = 'absolute';
                            planSentinel.style.top = '20%';
                            planSentinel.style.height = '1px';
                            planSentinel.style.width = '1px';
                            planSentinel.style.pointerEvents = 'none';
                            planSentinel.style.opacity = '0';
                            lastEl.appendChild(planSentinel);
                            observer.observeTrigger(planSentinel, 'plan');

                            const htmlSentinel = document.createElement('div');
                            htmlSentinel.className = 'infinite-html-sentinel';
                            htmlSentinel.style.position = 'absolute';
                            htmlSentinel.style.top = '80%';
                            htmlSentinel.style.height = '1px';
                            htmlSentinel.style.width = '1px';
                            htmlSentinel.style.pointerEvents = 'none';
                            htmlSentinel.style.opacity = '0';
                            lastEl.appendChild(htmlSentinel);
                            observer.observeTrigger(htmlSentinel, 'html');
                        }
                    }
                } else {
                    icError('Failed to load batch HTML');
                }
            }
        },
        onReachedMiddle: (target) => {
            queueManager.fetchPlan();
        },
        onReachedNearEnd: async (target) => {
            const isSingle = context.type === 'single';
            if (isSingle) {
                await loadAndInjectNextSingle();
            } else {
                if (queueManager.queue.length > 0 && !preFetchedBatchHtml) {
                    const items = [...queueManager.queue];
                    queueManager.queue = []; 
                    preFetchedBatchHtml = queueManager.fetchHtmlBatch(items); 
                }
            }
        },
        onActiveChange: (target) => {
            if (isProgrammaticScroll) return;

            const url = target.getAttribute('data-url');
            const title = target.getAttribute('data-title');
            const metaStr = target.getAttribute('data-meta');
            const targetId = target.getAttribute('data-id') || (metaStr ? JSON.parse(metaStr).id : null);

            let meta = null;
            try {
                if (metaStr) meta = JSON.parse(metaStr);
            } catch (e) {
                icError('Failed to parse meta from target', e);
            }

            icLog('Active:', title);

            // Таймер для пометки как "Прочитано" (Persistent History)
            if (viewTimer) {
                clearTimeout(viewTimer);
                viewTimer = null;
            }

            if (context.type === 'single' && targetId) {
                icLog(`Starting view timer (${historyViewDuration}s) for post ${targetId}`);
                viewTimer = setTimeout(() => {
                    queueManager.markAsRead(targetId);
                    icLog(`Post ${targetId} marked as READ due to time threshold.`);
                }, historyViewDuration * 1000);
            }

            if (url === lastTrackedUrl) {
                return;
            }
            lastTrackedUrl = url;

            uiController.setActiveElement(target);

            const allItems = Array.from(document.querySelectorAll('.ic-level-block'));
            const currentIndex = allItems.indexOf(target);
            
            if (currentIndex !== -1 && currentIndex < allItems.length - 1) {
                const nextElement = allItems[currentIndex + 1];
                uiController.setNextAnchor(nextElement);
            } else {
                uiController.setNextAnchor(null);
            }

            if (url && title) {
                const previousUrl = window.location.href;
                injector.updateHistory(url, title, meta);
                
                // Dispatch event for other modules (like Sidebars) to update their context
                if (syncSidebar) {
                    document.dispatchEvent(new CustomEvent('saborlista_post_changed', {
                        detail: {
                            post_id: targetId,
                            url: url,
                            title: title,
                            meta: meta
                        }
                    }));
                }
                
                if (window.SaborlistaAnalytics) {
                    const eventData = Object.assign({
                        page_title: title,
                        page_location: url,
                        page_path: new URL(url).pathname,
                        page_referrer: previousUrl,
                        navigation_type: 'infinite_scroll'
                    }, meta && meta.analytics ? meta.analytics : {});
                    
                    window.SaborlistaAnalytics.sendEvent('page_view', eventData, false);
                } else {
                    if (typeof gtag === 'function') {
                        gtag('event', 'page_view', {
                            page_title: title,
                            page_location: url,
                            page_path: new URL(url).pathname,
                            page_referrer: previousUrl
                        });
                    }
                }
            }
        }
    });

    observer.observeSentinel(sentinel);

    window.addEventListener('popstate', (event) => {
        if (event.state && event.state.url) {
            icLog('Popstate detected, navigating to:', event.state.url);
            const target = document.querySelector(`.ic-level-block[data-url="${event.state.url}"]`) || 
                           document.querySelector(`article[data-url="${event.state.url}"]`);
            
            if (target) {
                isProgrammaticScroll = true;

                const metaStr = target.getAttribute('data-meta');
                if (metaStr) {
                    try {
                        const meta = JSON.parse(metaStr);
                        injector.updateHeader(meta);
                        document.title = event.state.title || meta.title;

                        if (syncSidebar && meta.id) {
                            document.dispatchEvent(new CustomEvent('saborlista_post_changed', {
                                detail: {
                                    post_id: meta.id,
                                    url: event.state.url,
                                    title: event.state.title || meta.title,
                                    meta: meta
                                }
                            }));
                        }
                    } catch (e) {
                        icError('Failed to sync meta on popstate', e);
                    }
                }
                uiController.setActiveElement(target);

                const offset = 80; 
                const isLandingUrl = event.state.url === landingUrl;
                const isFirstPage = context.page === 1;
                
                if (isLandingUrl && isFirstPage) {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                } else {
                    const bodyRect = document.body.getBoundingClientRect().top;
                    const elementRect = target.getBoundingClientRect().top;
                    const elementPosition = elementRect - bodyRect;
                    const offsetPosition = elementPosition - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }

                setTimeout(() => {
                    isProgrammaticScroll = false;
                }, 1000);
            } else {
                icLog('Target for popstate not found in DOM, performing full reload');
                window.location.href = event.state.url;
            }
        }
    });

    const articles = document.querySelectorAll('article');
    const isSingle = context.type === 'single';

    const initialArticle = isSingle || articles.length < 3 || context.page === 1
        ? articles[0] 
        : articles[Math.floor(articles.length / 2)];

    if (initialArticle) {
        initialArticle.classList.add('ic-level-block');
        initialArticle.setAttribute('data-url', window.location.href);
        initialArticle.setAttribute('data-title', document.title);
        
        if (context.id) {
            initialArticle.setAttribute('data-id', context.id);
        }
        
        if (context.post_type) {
            initialArticle.setAttribute('data-type', context.post_type);
        }
        
        if (context.initial_meta) {
            initialArticle.setAttribute('data-meta', JSON.stringify(context.initial_meta));
            if (context.initial_meta.id) {
                initialArticle.setAttribute('data-id', context.initial_meta.id);
            }
        }

        observer.observeItem(initialArticle);
        initialArticle.style.position = 'relative'; 
        
        const planSentinel = document.createElement('div');
        planSentinel.className = 'infinite-plan-sentinel';
        planSentinel.style.position = 'absolute';
        planSentinel.style.top = '20%';
        planSentinel.style.height = '1px';
        planSentinel.style.width = '1px';
        planSentinel.style.pointerEvents = 'none';
        planSentinel.style.opacity = '0';
        initialArticle.appendChild(planSentinel);
        observer.observeTrigger(planSentinel, 'plan');

        const htmlSentinel = document.createElement('div');
        htmlSentinel.className = 'infinite-html-sentinel';
        htmlSentinel.style.position = 'absolute';
        htmlSentinel.style.top = '40%';
        htmlSentinel.style.height = '1px';
        htmlSentinel.style.width = '1px';
        htmlSentinel.style.pointerEvents = 'none';
        htmlSentinel.style.opacity = '0';
        initialArticle.appendChild(htmlSentinel);
        observer.observeTrigger(htmlSentinel, 'html');

        uiController.setActiveElement(initialArticle);
        uiController.setNextAnchor(null);    }

    icLog('Saborlista Infinite Scroll Initialized');
});
